import index from './zh-cn/index.js'
import login from './zh-cn/login.js'
import main from './zh-cn/main.js'
// common/check..

import base from './zh-cn/base/base.js'
import status from './zh-cn/base/status.js'

import notFound from './zh-cn/notFound.js'


//后台数据国际化
import i18nMain from './zh-cn/dataI18n/main.js'
import i18nStatus from './zh-cn/dataI18n/status.js'
import i18nInsuranceStatus from './zh-cn/dataI18n/insuranceStatus.js'


// 发票相关
import invoice_apply from './zh-cn/invoice_apply.js'
import invoice from './zh-cn/invoice.js'

//条款
import invoiceClause from './zh-cn/clause/invoiceClause.js'

// 修改个人信息
import modifyInfo from './zh-cn/modifyInfo.js'

// 展位相关
import chooseBooth from './zh-cn/chooseBooth.js'
import boothInfo from './zh-cn/boothInfo'
//施工图
import drawingsDetail from './zh-cn/drawings/drawingsDetail'
import drawingsIndex from './zh-cn/drawings/drawingsIndex'
import drawingsNotice from './zh-cn/drawings/drawingsNotice'
import drawingsBoothConfirm from './zh-cn/drawings/drawingsBoothConfirm'
import drawings from './zh-cn/drawings/drawings'
import drawingsBoothInfo from './zh-cn/drawings/drawingsBoothInfo'
import drawingsProducerInfo from './zh-cn/drawings/drawingsProducerInfo'
import drawingsUpload from './zh-cn/drawings/drawingsUpload'
import drawingsCarpet from './zh-cn/drawings/drawingsCarpet'
import drawingsEnd from './zh-cn/drawings/drawingEnd'
//楣板
import fascia from './zh-cn/fascia'

//承建商相关
import constructionPermit from './zh-cn/constructionPermit'

//缴费
import fee from './zh-cn/fee.js'
import feeConfirmation from './zh-cn/feeConfirmation.js'
import feeOfflinePayment from './zh-cn/feeOfflinePayment'
import fixedFee from './zh-cn/fixedFee.js'
import foregift from './zh-cn/foregift.js'
import order from './zh-cn/order'
import order_info from './zh-cn/order_info.js'
import shopList from './zh-cn/shopList.js'
import foodList from './zh-cn/foodList.js'
import SettlementList from './zh-cn/SettlementList'

//展位保险
import insuranceHome from './zh-cn/insuranceHome'


import booklet from './zh-cn/booklet'
import carLicenseApply from './zh-cn/carLicenseApply'
import qrCode from './zh-cn/qrCode'

//发票
import invoiceConfirmation from './zh-cn/invoiceConfirmation'

export default {
	status,
	base,
	drawingsCarpet,
	drawingsUpload,
	drawingsProducerInfo,
	drawings,
	drawingsBoothInfo,
	drawingsEnd,
	login,
	index,
	invoice_apply,
	invoice,
	modifyInfo,
	chooseBooth,
	shopList,foodList,
	fee,
	fixedFee,
	feeConfirmation,
	foregift,
	main,
	order_info,
	order,
	fascia,
	booklet,
	drawingsNotice,
	drawingsIndex,
	drawingsDetail,
	carLicenseApply,
	constructionPermit,
	insuranceHome,
	boothInfo,
	feeOfflinePayment,
	drawingsBoothConfirm,
	qrCode,
	i18nMain,
	invoiceConfirmation,
	SettlementList,
	i18nStatus,
	i18nInsuranceStatus,
	invoiceConfirmation,
	notFound,
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn.js